import Container from "../utils/Container"
import SectionTitle from "../utils/SectionTitle"
import BookImage from "../../assets/bouquin2.jpg"
import OfficeImage from "../../assets/bureau.webp"

const About = () => {
  return (
    <section id="about">
      <Container>
        <SectionTitle title="A Propos">
          <p>Le cabinet assiste les mis en cause mais aussi les parties civiles à tous les stades de la procédure (Garde à vue, audition libre, information judiciaire, audience correctionnelle, Cour criminelle, Cour d'assises, aménagement de peine).</p>
          <p>Maître Gibert intervient principalement en région parisienne mais aussi dans toute la France.</p>
        </SectionTitle>
        <main className="flex flex-col gap-10 lg:flex-row justify-center items-center">
          <div className="grid gap-5 sm:grid-cols-2 flex-[2]">
            <figure className="relative">
              <img src={OfficeImage} alt="office" className="w-full h-full" />
              {/* <figcaption className="absolute bottom-0 left-0 bg-secondary px-4 py-2 w-[80%]">
                <h3 className="font-bold">Luke Skywalker</h3>
                <span className="text-xs">Web Designer</span>
              </figcaption> */}
            </figure>
            <figure className="relative">
              <img src={BookImage} alt="books" className="w-full" />
            </figure>
          </div>
          <div className="text-center lg:text-start flex-[1]">
            <h1 className="text-xl font-bold mb-4"></h1>
            <p className="text-sm mb-4 leading-[2] text-justify">
              Victoire GIBERT est avocate au Barreau de Paris et exerce exclusivement en Droit Pénal.
            </p>
            <p className="text-sm mb-4 leading-[2] text-justify">
              Titulaire d’un Master 2 en Justice Pénale Internationale obtenu à l’Université Paris Panthéon Assas, Victoire GIBERT s’est formée au sein de prestigieux cabinets d’avocats pénalistes à Paris.
            </p>
            <p className="text-sm mb-4 leading-[2] text-justify">
              Passionnée par ce métier, Maître Victoire GIBERT fonde son propre cabinet en mai 2024 afin de proposer à ses clients une défense sur mesure grâce à une stratégie discutée et adaptée à chaque situation.
            </p>
          </div>
        </main>
      </Container>
    </section>
  )
}

export default About
